import termsTemplate from '../../pages/terms.html'
import privacyTemplate from '../../pages/privacy.html'
import childrensPrivacyTemplate from '../../pages/childrensPrivacy.html'
import template from './passwordForm.html'
import './passwordForm.less'

class PasswordFormController {
    constructor($uibModal) {
        'ngInject'
        this.$uibModal = $uibModal
    }

    $onInit() {
        this.passwordValidations = [
            { type: 'mmsMinlength', msg: 'Contain at least 8 characters' },
            {
                type: 'mmsIncludeUppercase',
                msg: 'Include at least 1 uppercase letter',
            },
            {
                type: 'mmsIncludeLowercase',
                msg: 'Include at least 1 lowercase letter',
            },
            { type: 'mmsIncludeNumber', msg: 'Include at least 1 number' },
            {
                type: 'mmsIncludeSpecialChar',
                msg: 'Include at least 1 special character -  (!,@,#,...)',
            },
        ]
        this.passwordLabel = this.passwordLabel || 'Password'
        this.confirmLabel = this.confirmLabel || 'Confirm Password'
        this.submitBtnLabel = this.submitBtnLabel || 'Save Password'
    }

    submitPassword(password) {
        this.onSubmitPassword({
            $event: {
                password,
                hipaaAuthorized: this.hipaaAuthorized,
                hipaaAuthorizedAt: this.hipaaAuthorizedAt,
                hipaaAuthorizedVersion: this.hipaaAuthorizedVersion
            },
        })
    }

    openTermsModal() {
        let modalInstance = this.$uibModal.open({
            backdropClass: 'mms-backdrop',
            template: `
        <div class="modal-body">${termsTemplate}</div>
        <div class="modal-footer px-4">
		    <button type="button" class="btn btn-primary btn-block" ng-click="$close()">Done</button>
	    </div>
      `,
        })
        modalInstance.result.catch(() => { })
    }

    openPrivacyModal() {
        let modalInstance = this.$uibModal.open({
            backdropClass: 'mms-backdrop',
            template: `
        <div class="modal-body">${privacyTemplate}</div>
        <div class="modal-footer px-4">
		    <button type="button" class="btn btn-primary btn-block" ng-click="$close()">Done</button>
	    </div>
      `,
        })
        modalInstance.result.catch(() => { })
    }

    openChildrensPrivacyModal() {
        let modalInstance = this.$uibModal.open({
            backdropClass: 'mms-backdrop',
            template: `
        <div class="modal-body">${childrensPrivacyTemplate}</div>
        <div class="modal-footer px-4">
		    <button type="button" class="btn btn-primary btn-block" ng-click="$close()">Done</button>
	    </div>
      `,
        })
        modalInstance.result.catch(() => { })
    }

    openHipaaModal() {
        const modalInstance = this.$uibModal.open({
            backdrop: 'static', // do not close modal on backdrop click
            backdropClass: 'mms-backdrop',
            component: 'mmsHipaaAuthorization',
            resolve: {
                userFullName: () => this.userFullName,
                hipaaAuthorizedAt: () => this.hipaaAuthorizedAt,
            }
        });
        modalInstance.result.then((result) => {
            this.hipaaAuthorized = result.hipaaAuthorized
            this.hipaaAuthorizedAt = result.hipaaAuthorizedAt
            this.hipaaAuthorizedVersion = result.hipaaAuthorizedVersion
        })
        modalInstance.result.catch((result) => {
            this.hipaaAuthorized = result.hipaaAuthorized
            this.hipaaAuthorizedAt = result.hipaaAuthorizedAt
            this.hipaaAuthorizedVersion = result.hipaaAuthorizedVersion
        });
    }
}

export const PasswordFormComponent = {
    name: 'mmsPasswordForm',
    component: {
        template: template,
        controller: PasswordFormController,
        bindings: {
            passwordLabel: '@',
            confirmLabel: '@',
            submitBtnLabel: '@',
            onSubmitPassword: '&',
            userFullName: '<'
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/common/passwordForm/passwordForm.component.js